/* Kleine chip- en coverage-badges voor de RoosterPage-live-check. */

export function ChipYesNo({ ok, label }) {
  return (
    <span className={`inline-flex items-center gap-1 text-[10px] font-medium px-1.5 py-0.5 rounded ${
      ok ? "bg-emerald-50 text-emerald-700" : "bg-red-50 text-red-700"
    }`}>
      {ok ? "✓" : "✗"} {label}
    </span>
  );
}

import { CheckCircle2, AlertTriangle } from "lucide-react";

export function Coverage({ label, ok, was, required = true, advisory = false }) {
  const changed = was !== undefined && ok !== was;
  const tone = ok
    ? "bg-emerald-50 border-emerald-200 text-emerald-800"
    : required
      ? (advisory ? "bg-neutral-50 border-neutral-200 text-neutral-600" : "bg-red-50 border-red-200 text-red-800")
      : "bg-neutral-50 border-neutral-200 text-neutral-500";
  return (
    <div className={`px-2 py-1.5 rounded-md border text-[11px] flex items-center justify-between ${tone}`}>
      <span>{label}</span>
      <span className="flex items-center gap-1">
        {ok ? <CheckCircle2 className="h-3.5 w-3.5" /> : <AlertTriangle className="h-3.5 w-3.5" />}
        {changed && <span className="text-[9px] opacity-75">{was ? "→ nu weg" : "nu OK"}</span>}
      </span>
    </div>
  );
}
